import { render, staticRenderFns } from "./content-banner.vue?vue&type=template&id=594dec72&scoped=true&"
import script from "./content-banner.vue?vue&type=script&lang=js&"
export * from "./content-banner.vue?vue&type=script&lang=js&"
import style0 from "./content-banner.vue?vue&type=style&index=0&id=594dec72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594dec72",
  null
  
)

export default component.exports